<template>
  <div class="grid-y flex-grow divide-y">
    <div class="flex-shrink-0 container-tabs padding-horizontal-2 flex flex-row justify-between">
      <RouterTabs :tabs="tabs"/>
      <div
        class="flex flex-row items-center space-x-10"
        v-if="$route.name === 'contractors.details.info'">
        <template v-if="contractor">
          <template v-if="$delve(contractor, 'blockingReason') === null">
            <span
              class="text-16px leading-18px text-secondary font-bold cursor-pointer"
              @click="$router.push({
                name: 'contractors.details.edit',
                params: { id },
              })">
              Редактировать профиль
            </span>
            <span
              class="text-16px leading-18px text-danger font-bold cursor-pointer"
              v-b-modal="'disconnect'">
              Заблокировать
            </span>
            <span
              class="text-16px leading-18px text-danger font-bold cursor-pointer"
              v-b-modal="'user-delete'">
              Удалить
            </span>
          </template>
          <template v-else>
            <span
              class="text-16px leading-18px text-primary font-bold cursor-pointer"
              @click="unblock">
              Подключить
            </span>
          </template>
        </template>
      </div>
    </div>
    <div class="cell auto flex">
      <div class="grid-x flex-grow">
        <div class="cell auto cell-block-y flex flex-grow">
          <router-view :id="id"></router-view>
        </div>
      </div>
    </div>
    <UserBlockingModal @block="block"/>
    <UserDeleteModal @delete="userDelete"/>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapGetters, mapActions } from 'vuex';
import RouterTabs from '@/components/RouterTabs.vue';
import UserBlockingModal from '@/components/User/UserBlockingModal.vue';
import UserDeleteModal from '@/components/User/UserDeleteModal.vue';

export default {
  components: {
    RouterTabs,
    UserBlockingModal,
    UserDeleteModal,
  },
  computed: {
    ...mapGetters({
      contractors: 'contractors/contractors',
    }),
    id() {
      return _.get(this.$route, 'params.id');
    },
    contractor() {
      return this.contractors(this.id);
    },
    tabs() {
      return [
        {
          title: 'Информация',
          push: {
            name: 'contractors.details.info',
            params: {
              id: this.id,
            },
          },
        },
        {
          title: 'Список заказов',
          push: {
            name: 'contractors.details.orders',
            params: {
              id: this.id,
            },
          },
        },
        {
          title: 'Транзакции',
          push: {
            name: 'contractors.details.transactions',
            params: {
              id: this.id,
            },
          },
        },
        {
          title: 'Коммуникации',
          push: {
            name: 'contractors.details.communications',
            params: {
              id: this.id,
            },
          },
        },
      ];
    },
  },
  methods: {
    ...mapActions({
      fetch: 'contractors/ACT_FETCH_CONTRACTOR',
      setBlocking: 'contractors/ACT_SET_CONTRACTOR_BLOCKING',
      deleteContractor: 'contractors/ACT_DELETE_CONTRACTOR',
    }),
    unblock() {
      this.setBlocking({
        id: this.id,
        reason: null,
      });
    },
    block(event) {
      this.setBlocking({
        id: this.id,
        reason: event,
      }).finally(() => {
        this.$bvModal.hide('disconnect-data');
      });
    },
    userDelete() {
      this.deleteContractor(this.id).then(() => {
        this.$router.push({
          name: 'contractors',
        });
      });
    },
  },
  watch: {
    id: {
      handler(value) {
        if (value) {
          this.fetch(value);
        }
      },
      immediate: true,
    },
  },
};
</script>
